export function isErrorType(object: any): object is ErrorType {
  return 'errorType' in object;
}

export type ErrorType = {
  errorType: 'userNotAuthenticated';
};
